import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region ../icons/dist/react/default/captions-off.js
const CaptionsOffIcon = (props, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 18,
	fill: "none",
	"aria-hidden": "true",
	viewBox: "0 0 18 18",
	ref,
	...props,
	children: [
		/* @__PURE__ */ jsx("rect", {
			width: 16,
			height: 12,
			x: 1,
			y: 3,
			stroke: "currentColor",
			strokeWidth: 2,
			rx: 3
		}),
		/* @__PURE__ */ jsx("rect", {
			width: 3,
			height: 2,
			x: 3,
			y: 8,
			fill: "currentColor",
			fillOpacity: .5,
			rx: 1
		}),
		/* @__PURE__ */ jsx("rect", {
			width: 2,
			height: 2,
			x: 13,
			y: 8,
			fill: "currentColor",
			fillOpacity: .5,
			rx: 1
		}),
		/* @__PURE__ */ jsx("rect", {
			width: 4,
			height: 2,
			x: 11,
			y: 11,
			fill: "currentColor",
			fillOpacity: .5,
			rx: 1
		}),
		/* @__PURE__ */ jsx("rect", {
			width: 5,
			height: 2,
			x: 7,
			y: 8,
			fill: "currentColor",
			fillOpacity: .5,
			rx: 1
		}),
		/* @__PURE__ */ jsx("rect", {
			width: 7,
			height: 2,
			x: 3,
			y: 11,
			fill: "currentColor",
			fillOpacity: .5,
			rx: 1
		})
	]
});
const ForwardRef = forwardRef(CaptionsOffIcon);
//#endregion
export { ForwardRef as default };

//# sourceMappingURL=captions-off.js.map